<template>
    <el-dialog :visible.sync="showDialog" @open="loadServiceCompany" @close="closeDialog" width="750px" :close-on-click-modal="false">
        <el-tabs v-model="activeStep"
                 v-loading="loading">
            <el-tab-pane :label="(serviceCompanyId === null ? $t('common.create') : $t('common.update')) + ' ' + $t('common.serviceCompany')"
                         name="serviceCompany"
                         v-loading="loading">
                <el-form v-loading="loading" ref="form" :model="form" :rules="rules" size="small" label-width="200px" label-position="left">
                    <el-form-item :label="$t('common.code')" prop="code">
                        <el-input :disabled="serviceCompanyId !== null" v-model="form.code"></el-input>
                    </el-form-item>

                    <el-form-item :label="$t('common.name')" prop="name">
                        <el-input v-model="form.name"></el-input>
                    </el-form-item>

                    <el-form-item v-if="$isFullAdmin" :label="$t('masters.epicorSupplierCode')" prop="epicorSupplierCode">
                        <el-input v-model="form.epicorSupplierCode"></el-input>
                    </el-form-item>

                    <el-form-item :label="$t('common.contactPerson')" prop="contactPersonName">
                        <el-input v-model="form.contactPersonName"></el-input>
                    </el-form-item>

                    <el-form-item :label="$t('masters.companyType')" prop="companyType">
                        <el-radio-group v-model="form.companyType">
                            <el-radio label="1">{{$t('masters.regular')}}</el-radio>
                            <el-radio label="2">{{$t('masters.parent')}}</el-radio>
                            <el-radio label="3">{{$t('masters.subAgent')}}</el-radio>
                        </el-radio-group>
                    </el-form-item>
                    <el-form-item :label="$t('masters.parentAccount')" prop="parentAccount" v-if="form.companyType == 3">
                        <el-select v-model="form.parentCompanyId">
                            <el-option v-for="item in parentCompanies" :key="item.id" :label="item.name" :value="item.id"></el-option>
                        </el-select>
                    </el-form-item>
                    <el-form-item :label="$t('masters.rating')" prop="rating">
                        <el-radio-group v-model="form.rating">
                            <el-radio label="1">A</el-radio>
                            <el-radio label="2">B</el-radio>
                            <el-radio label="3">C</el-radio>
                        </el-radio-group>
                    </el-form-item>

                    <el-form-item :label="$t('masters.isLimited')">
                        <el-switch v-model="form.isLimited"></el-switch>
                    </el-form-item>

                    <el-form-item :label="$t('masters.isAuthorized')">
                        <el-switch v-model="form.isAuthorized"></el-switch>
                    </el-form-item>

                    <address-selector v-model="form"></address-selector>

                    <el-form-item label="GST" prop="gst" v-if="isCanadian">
                        <el-input v-model="form.gst"></el-input>
                    </el-form-item>

                    <el-form-item label="PST" prop="qst" v-if="isCanadian">
                        <el-input v-model="form.qst"></el-input>
                    </el-form-item>

                    <h3>{{$t('masters.contactInfo')}}</h3>

                    <el-form-item :label="$t('masters.bilingAccountEmail')" prop="email">
                        <el-input v-model="form.email"></el-input>
                    </el-form-item>

                    <el-form-item :label="$t('masters.serviceEmail')" prop="serviceEmail">
                        <el-input v-model="form.serviceEmail"></el-input>
                    </el-form-item>

                    <el-form-item :label="$t('masters.serviceEmail2')" prop="serviceEmail2">
                        <el-input v-model="form.serviceEmail2"></el-input>
                    </el-form-item>

                    <el-form-item :label="$t('masters.partsEmail')" prop="partsEmail">
                        <el-input v-model="form.partsEmail"></el-input>
                    </el-form-item>

                    <el-form-item :label="$t('common.phone')" prop="phone">
                        <el-input v-model="form.phone" v-mask="'(###) ###-####'"></el-input>
                    </el-form-item>

                    <h3>{{$t('masters.warrantyRates')}}</h3>
                    <p v-if="serviceCompanyId !== null">{{$t('masters.lastUpdate')}} {{form.lastRatesUpdate | date}}</p>
                    <h4 class="rate-input-set">{{$t('masters.regularTimeRates')}}</h4>
                    <el-row :gutter="10">
                        <el-col :span="8">
                            <el-form-item prop="warrantyRegularLaborRate" label-width="0" :label="$t('common.labor')">
                                <el-input v-model.number="form.warrantyRegularLaborRate" :placeholder="$t('masters.laborRate')"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item prop="warrantyRegularTravelRate" label-width="0" :label="$t('masters.travel')">
                                <el-input v-model.number="form.warrantyRegularTravelRate" :placeholder="$t('masters.travelRate')"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item prop="warrantyRegularMileageRate" label-width="0" :label="$t('common.mileage')">
                                <el-input v-model.number="form.warrantyRegularMileageRate" :placeholder="$t('masters.mileageRate')"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <h4 class="rate-input-set">{{$t('masters.overtimeRates')}}</h4>
                    <el-row :gutter="10">
                        <el-col :span="8">
                            <el-form-item prop="warrantyOvertimeLaborRate" label-width="0" :label="$t('common.labor')">
                                <el-input v-model.number="form.warrantyOvertimeLaborRate" :placeholder="$t('masters.laborRate')"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item prop="warrantyOvertimeTravelRate" label-width="0" :label="$t('masters.travel')">
                                <el-input v-model.number="form.warrantyOvertimeTravelRate" :placeholder="$t('masters.travelRate')"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item prop="warrantyOvertimeMileageRate" label-width="0" :label="$t('common.mileage')">
                                <el-input v-model.number="form.warrantyOvertimeMileageRate" :placeholder="$t('masters.mileageRate')"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                    <h3>{{$t('masters.nonWarrantyRates')}}</h3>
                    <h4 class="rate-input-set">{{$t('masters.regularTimeRates')}}</h4>
                    <el-row :gutter="10">
                        <el-col :span="8">
                            <el-form-item prop="nonWarrantyRegularLaborRate" label-width="0" :label="$t('common.labor')">
                                <el-input v-model.number="form.nonWarrantyRegularLaborRate" :placeholder="$t('masters.laborRate')"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item prop="nonWarrantyRegularTravelRate" label-width="0" :label="$t('masters.travel')">
                                <el-input v-model.number="form.nonWarrantyRegularTravelRate" :placeholder="$t('masters.travelRate')"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item prop="nonWarrantyRegularMileageRate" label-width="0" :label="$t('common.mileage')">
                                <el-input v-model.number="form.nonWarrantyRegularMileageRate" :placeholder="$t('masters.mileageRate')"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>

                    <h4 class="rate-input-set">{{$t('masters.overtimeRates')}}</h4>
                    <el-row :gutter="10">
                        <el-col :span="8">
                            <el-form-item prop="nonWarrantyOvertimeLaborRate" label-width="0" :label="$t('common.labor')">
                                <el-input v-model.number="form.nonWarrantyOvertimeLaborRate" :placeholder="$t('masters.laborRate')"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item prop="nonWarrantyOvertimeTravelRate" label-width="0" :label="$t('masters.travel')">
                                <el-input v-model.number="form.nonWarrantyOvertimeTravelRate" :placeholder="$t('masters.travelRate')"></el-input>
                            </el-form-item>
                        </el-col>
                        <el-col :span="8">
                            <el-form-item prop="nonWarrantyOvertimeMileageRate" label-width="0" :label="$t('common.mileage')">
                                <el-input v-model.number="form.nonWarrantyOvertimeMileageRate" :placeholder="$t('masters.mileageRate')"></el-input>
                            </el-form-item>
                        </el-col>
                    </el-row>
                </el-form>
            </el-tab-pane>
            <el-tab-pane :label="$t('common.subContractor')"
                         name="subContractor"
                         v-loading="loading"
                         v-if="serviceCompanyId !== null">
                <el-form v-loading="loading" ref="formSubContractor" :model="formSubContractor" :rules="rulesSubContractor" size="small" label-width="140px" label-position="left">
                    <el-form-item :label="$t('common.name')" prop="name">
                        <el-input v-model="formSubContractor.name"></el-input>
                    </el-form-item>

                    <el-form-item :label="$t('common.contactPerson')" prop="contactName">
                        <el-input v-model="formSubContractor.contactName"></el-input>
                    </el-form-item>

                    <h3>{{$t('masters.contactInfo')}}</h3>

                    <el-form-item :label="$t('common.phone')" prop="phone">
                        <el-input v-model="formSubContractor.phone" v-mask="'(###) ###-####'"></el-input>
                    </el-form-item>

                    <el-form-item :label="$t('common.email')" prop="email">
                        <el-input v-model="formSubContractor.email"></el-input>
                    </el-form-item>
                </el-form>
                <el-button :disabled="loading" type="primary" @click="addSubcontractor">{{ formSubContractor.id ? $t('common.update') : $t('common.add') }}</el-button>
                <div class="subcontractors">
                    <el-row class="subcontractors-header" v-if="subcontractors.length > 0">
                        <el-col :span="5"> {{$t('common.name')}} </el-col>
                        <el-col :span="5"> {{$t('common.contact')}} </el-col>
                        <el-col :span="5"> {{$t('common.phone')}} </el-col>
                        <el-col :span="7"> {{$t('common.email')}} </el-col>
                    </el-row>
                    <el-row v-for="subcontractor in subcontractors"
                            :key="subcontractor.id">
                        <el-col :span="5"> {{subcontractor.name}} </el-col>
                        <el-col :span="5"> {{subcontractor.contactName}} </el-col>
                        <el-col :span="5"> {{subcontractor.phone}} </el-col>
                        <el-col :span="7"> {{subcontractor.email}} </el-col>
                        <i size="mini"
                           @click="editSubcontractor(subcontractor)">
                            <i class="el-icon-edit"></i>
                        </i>
                        <i size="mini"
                           @click="deleteSubcontractor(subcontractor)">
                            <i class="el-icon-delete"></i>
                        </i>
                    </el-row>
                </div>
            </el-tab-pane>
            <el-tab-pane :label="$t('masters.branchContractor')"
                         name="branchContractor"
                         v-loading="loading"
                         v-if="form.companyType == 2">
                <el-form v-loading="loading" ref="form" :model="form" :rules="rules" size="small" label-width="140px" label-position="left">
                    <span v-for="item in form.childCompaniesList" style="display:flex; justify-content:space-around">
                        <span>
                            <el-label>{{$t('common.code')}}</el-label>
                            <el-input v-model="item.code" :disabled="true">
                            </el-input>
                        </span>
                        <span>
                            <el-label>{{$t('common.name')}}</el-label>
                            <el-input v-model="item.name" :disabled="true">
                            </el-input>
                        </span>
                        <span style="margin-top: auto">
                            <el-button @click="navigateToBranchContractor(item.id)" style="max-height: 40px">
                                {{$t('common.link')}}
                            </el-button>
                        </span>
                    </span>
                </el-form>
            </el-tab-pane>
        </el-tabs>
        <span slot="footer" v-if="activeStep == 'serviceCompany'">
            <el-button :disabled="loading" type="primary" @click="resetPassword" v-if="$isFullAdmin&&serviceCompanyId" :title="$t('common.weWillSendEmailToResetPassword')">{{$t('common.resetPassword')}}</el-button>
            <el-button :disabled="loading" type="primary" @click="save" v-if="$isFullAdmin">{{serviceCompanyId === null ? $t('common.create') : $t('common.update')}}</el-button>
            <el-button :disabled="loading" @click="closeDialog">{{$t('common.cancel')}}</el-button>
        </span>
    </el-dialog>
</template>

<script>

import { AddressSelector, ChainSelector } from "@/app/shared/components";
import api from "../api";
    export default {
        name: "create-update-service-company-dialog",
        components: {
            AddressSelector,
            ChainSelector
        },
        props: {
            visible: {
                type: Boolean,
                default: false
            },
            serviceCompanyId: {
                required: false
            }
        },
        data() {
            return {
                form: {
                    code: undefined,
                    name: undefined,
                    epicorSupplierCode: undefined,
                    contactPersonName: undefined,
                    rating: undefined,
                    isLimited: undefined,
                    isAuthorized: undefined,
                    selectedCountryState: undefined,
                    city: undefined,
                    address: undefined,
                    regional: undefined,
                    region: undefined,
                    zip: undefined,
                    qst: undefined,
                    gst: undefined,
                    phone: undefined,
                    email: undefined,
                    serviceEmail: undefined,
                    serviceEmail2: undefined,
                    partsEmail: undefined,
                    shipToName: undefined
                },
                rules: {
                    code: [
                        {
                            required: true,
                            message: this.$t('common.pleaseEnterServiceCompanyCode'),
                            trigger: "blur"
                        }
                    ],
                    name: [
                        {
                            required: true,
                            message: this.$t('common.pleaseEnterServiceCompanyName'),
                            trigger: "blur"
                        }
                    ],
                    contactPersonName: [
                        {
                            required: true,
                            message: this.$t('common.pleaseEnterContactPersonName'),
                            trigger: "blur"
                        }
                    ],
                    rating: [
                        {
                            required: true,
                            message: this.$t('common.pleaseEnterRating'),
                            trigger: "change"
                        }
                    ],
                    selectedCountryState: [
                        {
                            type: "array",
                            required: true,
                            message: this.$t('common.pleaseEnterProvinceAndCountry'),
                            trigger: "change"
                        }
                    ],
                    gst: [
                        {
                            validator: (rule, value, callback) => {
                                if (this.isCanadian && (!value || value === "")) {
                                    callback(new Error(this.$t('common.gstNumberIsRequired')));
                                } else {
                                    callback();
                                }
                            },
                            trigger: "blur"
                        }
                    ],
                    qst: [
                        {
                            validator: (rule, value, callback) => {
                                if (this.isCanadian && (!value || value === "")) {
                                    callback(new Error(this.$t('common.pstNumberIsRequired')));
                                } else {
                                    callback();
                                }
                            },
                            trigger: "blur"
                        }
                    ],

                    city: [
                        {
                            required: true,
                            message: this.$t('common.pleaseEnterCity'),
                            trigger: "blur"
                        }
                    ],
                    shipToName: [
                        {
                            validator: (rule, value, callback) =>
                            {
                                if (this.form.shipToName)
                                {
                                    if (!this.form.shipToName.trim())
                                    {
                                        return callback(new Error(this.$confirm(this.$t('common.pleaseEnterCompanyName'))))
                                    }
                                    else return callback();
                                }
                                else return callback(new Error(this.$confirm(this.$t('common.pleaseEnterCompanyName'))))
                            },
                            required: true,
                            trigger: "blur"
                        }
                    ],
                    address: [
                        {
                            required: true,
                            message: this.$t('common.pleaseEnterAddress'),
                            trigger: "blur"
                        }
                    ],
                    shipToName: [
                        {
                            validator: (rule, value, callback) =>
                            {
                                if (this.form.shipToName)
                                {
                                    if (!this.form.shipToName.trim())
                                    {
                                        return callback(new Error(this.$confirm(this.$t('common.pleaseEnterCompanyName'))))
                                    }
                                    else return callback();
                                }
                                else return callback(new Error(this.$confirm(this.$t('common.pleaseEnterCompanyName'))))
                            },
                            required: true,
                            trigger: "blur"
                        }
                    ],
                    zip: [
                        {
                            required: true,
                            message: this.$t('common.pleaseEnterZip'),
                            trigger: "blur"
                        }
                    ],
                    email: [
                        {
                            required: true,
                            message: this.$t('common.pleaseEnterEmail'),
                            trigger: "blur"
                        }
                    ],
                    serviceEmail: [
                        {
                            required: true,
                            message: this.$t('common.pleaseEnterServiceEmail'),
                            trigger: "blur"
                        }
                    ],
                    partsEmail: [
                        {
                            required: true,
                            message: this.$t('common.pleaseEnterPartsEmail'),
                            trigger: "blur"
                        }
                    ],
                    phone: [
                        {
                            required: true,
                            message: this.$t('common.pleaseEnterPhone'),
                            trigger: "blur"
                        }
                    ],

                    warrantyRegularLaborRate: [
                        {
                            type: "number",
                            required: true,
                            message: this.$t('common.pleaseEnterRate'),
                            trigger: "blur"
                        }
                    ],
                    warrantyRegularTravelRate: [
                        {
                            type: "number",
                            required: true,
                            message: this.$t('common.pleaseEnterRate'),
                            trigger: "blur"
                        }
                    ],
                    warrantyRegularMileageRate: [
                        {
                            type: "number",
                            required: true,
                            message: this.$t('common.pleaseEnterRate'),
                            trigger: "blur"
                        }
                    ],

                    warrantyOvertimeLaborRate: [
                        {
                            type: "number",
                            required: true,
                            message: this.$t('common.pleaseEnterRate'),
                            trigger: "blur"
                        }
                    ],
                    warrantyOvertimeTravelRate: [
                        {
                            type: "number",
                            required: true,
                            message: this.$t('common.pleaseEnterRate'),
                            trigger: "blur"
                        }
                    ],
                    warrantyOvertimeMileageRate: [
                        {
                            type: "number",
                            required: true,
                            message: this.$t('common.pleaseEnterRate'),
                            trigger: "blur"
                        }
                    ],

                    nonWarrantyRegularLaborRate: [
                        {
                            type: "number",
                            required: true,
                            message: this.$t('common.pleaseEnterRate'),
                            trigger: "blur"
                        }
                    ],
                    nonWarrantyRegularTravelRate: [
                        {
                            type: "number",
                            required: true,
                            message: this.$t('common.pleaseEnterRate'),
                            trigger: "blur"
                        }
                    ],
                    nonWarrantyRegularMileageRate: [
                        {
                            type: "number",
                            required: true,
                            message: this.$t('common.pleaseEnterRate'),
                            trigger: "blur"
                        }
                    ],

                    nonWarrantyOvertimeLaborRate: [
                        {
                            type: "number",
                            required: true,
                            message: this.$t('common.pleaseEnterRate'),
                            trigger: "blur"
                        }
                    ],
                    nonWarrantyOvertimeTravelRate: [
                        {
                            type: "number",
                            required: true,
                            message: this.$t('common.pleaseEnterRate'),
                            trigger: "blur"
                        }
                    ],
                    nonWarrantyOvertimeMileageRate: [
                        {
                            type: "number",
                            required: true,
                            message: this.$t('common.pleaseEnterRate'),
                            trigger: "blur"
                        }
                    ]
                },
                loading: false,
                showDialog: this.visible,
                activeStep: "serviceCompany",
                formSubContractor:
                {
                    id: undefined,
                    name: undefined,
                    contactName: undefined,
                    phone: undefined,
                    email: undefined
                },
                rulesSubContractor: {
                    name: [
                        {
                            required: true,
                            message: this.$t('common.pleaseEnterSubContractorName'),
                            trigger: "blur"
                        }
                    ],
                    contactName: [
                        {
                            required: true,
                            message: this.$t('common.pleaseEnterContactName'),
                            trigger: "blur"
                        }
                    ],
                    email: [
                        {
                            required: true,
                            message: this.$t('common.pleaseEnterEmail'),
                            trigger: "blur"
                        }
                    ],
                    phone: [
                        {
                            required: true,
                            message: this.$t('common.pleaseEnterPhone'),
                            trigger: "blur"
                        }
                    ],
                },
                subcontractors: {}
            };
        },
        watch: {
            visible: function (val) {
                this.showDialog = val;
            }
        },
        computed: {
            isCanadian() {
                return (
                    this.form.selectedCountryState &&
                    this.form.selectedCountryState[0] === "2"
                );
            },
            isQuebec() {
                return this.isCanadian && this.form.selectedCountryState[1] === "49";
            }
        },
        methods: {
            loadServiceCompany() {
                this.loading = true;
                if (this.serviceCompanyId) {
                    api.getServiceCompany(this.serviceCompanyId).then(serviceCompany => {
                        this.loading = false;
                        this.form = Object.assign({}, serviceCompany);
                        this.subcontractors = serviceCompany.subcontractors;
                    });
                }
                    api.getParentServiceCompanies().then(result => {
                        this.loading = false;
                        this.parentCompanies = result.data;
                    })
            },
            navigateToBranchContractor(id) {
                this.closeDialog();
                this.loading = true;
                api.getServiceCompany(id).then(serviceCompany => {
                        this.loading = false;
                        this.form = Object.assign({}, serviceCompany);
                        this.subcontractors = serviceCompany.subcontractors;
                        this.showDialog = true;
                    });
            },
            closeDialog() {
                this.activeStep = "serviceCompany";
                this.$refs["form"].resetFields();
                this.resetSubcontractorForm();
                this.subcontractors = {};
                this.parentCompanies = {};
                this.showDialog = false;
                this.loading = false;
                this.$emit("dialogClosed");
            },
            save() {
                this.$refs["form"].validate(valid => {
                    if (valid) {
                        this.loading = true;
                        api.saveServiceCompany(this.serviceCompanyId, this.form).then(
                            response => {
                                this.$emit("save", {
                                    new: this.serviceCompanyId === undefined,
                                    id: this.serviceCompanyId,
                                    data: this.form
                                });
                                this.closeDialog();
                            },
                            err => {
                                this.loading = false;
                                let message = "";
                                try {
                                    message = Object.values(err.response.data).join(" ");
                                } catch (e) {
                                    message = this.$t('common.cantCreateNewCompany');
                                }

                                this.$message.error(message);
                            }
                        );
                    } else {
                        return false;
                    }
                });
            },
            resetPassword() {
                this.$confirm(
                    this.$t('common.weWillSendEmailToResetPasswordContinue'),
                    "Warning",
                    {
                        confirmButtonText: this.$t('common.OK'),
                        cancelButtonText: this.$t('common.cancel'),
                        type: "warning"
                    }
                )
                    .then(() => {
                        api.resetPassword(this.serviceCompanyId).then(() => {
                            this.$notify({
                                title: this.$t('common.success'),
                                message: this.$t('common.emailWasSent'),
                                type: "success"
                            });
                        });
                    })
                    .catch(_ => { });
            },
            addSubcontractor() {
                this.$refs["formSubContractor"].validate(valid => {
                    if (valid) {
                        this.loading = true;
                        api.addSubcontractor(this.serviceCompanyId, this.formSubContractor).then(response => {
                            this.loading = false;
                            this.resetSubcontractorForm();
                            if (response.data) {
                                var edited = this.subcontractors.filter(
                                    item => item.id === response.data.id
                                );
                                if (edited.length) {
                                    edited[0].name = response.data.name;
                                    edited[0].contactName = response.data.contactName;
                                    edited[0].phone = response.data.phone;
                                    edited[0].email = response.data.email;
                                    this.resetSubcontractorForm();
                                } else {
                                    this.subcontractors.push(response.data);
                                }
                            }
                        });
                    }
                })
            },
            editSubcontractor(subcontractor) {
                this.formSubContractor.id = subcontractor.id;
                this.formSubContractor.name = subcontractor.name;
                this.formSubContractor.contactName = subcontractor.contactName;
                this.formSubContractor.phone = subcontractor.phone;
                this.formSubContractor.email = subcontractor.email;
            },
            deleteSubcontractor(subcontractor) {
                this.$confirm(this.$t('common.areYouSureToDeleteTheSubcontractor'), "Warning", {
                    confirmButtonText: this.$t('common.OK'),
                    cancelButtonText: this.$t('common.cancel'),
                    type: "warning"
                })
                    .then(() => {
                        api.deleteSubcontractor(this.serviceCompanyId, subcontractor).then(response => {
                            this.loading = false;
                            this.resetSubcontractorForm();
                            if (response.data.id) {
                                this.subcontractors = this.subcontractors.filter(
                                    item => item.id !== response.data.id
                                );
                            }
                            this.$message({
                                type: "success",
                                message: this.$t('common.deleteCompleted')
                            });
                        });
                    })
                    .catch(() => {
                        this.loading = false;
                    });
            },
            resetSubcontractorForm() {
                if (this.$refs["formSubContractor"]) {
                    this.$refs["formSubContractor"].resetFields();
                    this.formSubContractor.id = undefined;
                }
            }
        }
    };
</script>

<style scoped>
.rate-input-set {
  margin-top: 0;
  margin-bottom: 5px;
}

.subcontractors-header{
    font-weight: bold;
    color: #606266;
    line-height: 24px;
    font-size: 14px;
}
.subcontractors{
    padding: 10px;
}
</style>



// WEBPACK FOOTER //
// ClientApp/app/masters/servicecompanies/components/CreateUpdateServiceCompanyDialog.vue